<template>
    <ac-modal title="Manage Affiliation Settings" ref="modalRef" :size-class="'modal-md'">
        <template>
            <div class="row">
                <div class="col-xs-12">
                    <form>
                        <div class="row">
                            <div class="col-lg-12 info-board info-board-blue">
                                <p class="text-primary">
                                    Changing these settings will apply when using an Affiliation Link to join Accresa for the selected Provider.
                                </p>
                            </div>
                        </div>
                        <hr />
                        <div class="row">
                            <div class="col-lg-7">
                                <p>Show Accresa Plans</p>
                            </div>
                            <div class="col-lg-5" data-bind="with: affiliationSettings">
                                <div class="switch">
                                    <label>
                                        No
                                        <input type="checkbox" v-model="showAccresaMemberships">
                                        <span class="lever"></span> Yes
                                    </label>
                                </div>
                            </div>
                        </div>
                    </form>
                    <div class="modal-footer">
                        <div class="button-box">
                            <ac-button class="btn btn-sm btn-red" :action="closeModal">Cancel</ac-button>
                            <ac-button class="btn btn-sm btn-green" :action="setAffiliationSettings">Set Affiliation Settings</ac-button>
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </ac-modal>
</template>

<script>
    import {common} from "../../../../global/common.js";
    import {api} from "../../../../global/framework/api.js";

    export default {
        name: "ManageAffiliationSettingsModal",
        props: {},
        data() {
            return {
                showAccresaMemberships: {
                    type: [Boolean]
                },
                affiliationSettings: {}
            };
        },
        methods: {
            showModal(providerEntityId) {
                this.affiliationSettings = this.getAffiliationSettings(providerEntityId);
                this.$refs.modalRef.open();
            },
            closeModal() {
                this.$refs.modalRef.close();
            },
            async getAffiliationSettings(providerEntityId) {
                let data = await api.getDataById("Admin", "GetAffiliationSettings", providerEntityId);
                this.affiliationSettings = data;
                this.showAccresaMemberships = this.affiliationSettings.showAccresaMemberships;
            },
            async setAffiliationSettings() {
                this.affiliationSettings.showAccresaMemberships = this.showAccresaMemberships;
                let result = await api.post('Admin', 'SaveAffiliationSettings', this.affiliationSettings);
                if(result) {
                    this.closeModal();
                }
            }
        }
    }
</script>

<style scoped>
    .modal-footer {
        padding-left: 0;
        padding-right: 0;
        margin-top: 12px;
    }
</style>